{
  "cms.catalogRow.action.discardStagedEdit": "Discard content changes",
  "cms.discardStagedEdit.confirm.title": "Discard content changes?",
  "cms.discardStagedEdit.confirm.body": "The unpublished content changes will be permanently deleted. The published content stays as it is.",
  "cms.discardStagedEdit.confirm.confirm": "Discard content changes",
  "cms.discardStagedEdit.confirm.cancel": "Cancel",
  "cms.discardStagedEdit.success": "Content changes discarded.",
  "cms.discardStagedEdit.error": "Discarding the content changes failed. Please try again."
}
